module.exports = __webpack_public_path__ + "media/images/home-cc3d5e2b49657fa9cf0c936d8ac9d112.jpg";